import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { tap } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import { MessageService } from 'primeng/components/common/messageservice';

import { environment } from '../../../environments/environment';
import { BaseService } from '../base/util/base.service';


@Injectable()
export class LogService extends BaseService {

  public isEditingGto = new Subject<boolean>();

  constructor(
    public http: HttpClient,
    public messageService: MessageService
  ) {
    super(http, messageService);
  }

  registraEvento(gto: string, evento: string) {
    const url = `${environment.urlLog}/registra-evento`;
    const registro = {
      gto,
      evento
    };

    this.http.post(url, registro).pipe(
      tap(response => {})
    ).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gto-detalhes/log.service.ts